import { Card, CardBody, Col } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import { averagePerDayData } from "../../../../Data/Widgets/GeneralWidgetsData";
import ReactApexChart from "react-apexcharts";
import { ArrowUp } from "react-feather";

const AverageSales = () => {
  return (
    <>
      {averagePerDayData.map((data,i)=>(
        <Col xxl="3" sm="6" key={i}>
          <Card className="height-equal radial-height">
            <CardBody className="radial-progress-card">
              <div>
                <H4 className="mb-0">{data.header}</H4>
                <div className="sale-details">
                  <H4 className={`font-${data.color} mb-0`}>{data.count}</H4>
                  <span className="f-12 f-light f-w-500">
                    <ArrowUp />
                    {data.per}
                  </span>
                </div>
                <P className="f-light">{data.description}</P>
              </div>
              <div className="radial-chart-wrap">
                <ReactApexChart options={data.chart} series={data.chart.series} type="radialBar" height={130} />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default AverageSales;
